import { connect } from 'react-redux';

import { DescriptionLayout, IDescriptionLayoutStateProps } from '.';
import { IState } from '../../../store';
import { getInfrastructureElements } from '../../../utils/get_infrastructure_list';
import { isArrayWithItems } from '../../../utils/helpers';

export function mapStateToProps(state: IState): IDescriptionLayoutStateProps {
  const { communicationSet, infrastructureList, description = '' } = state.villageData.village;

  return {
    description,
    joinBottom:
      !state.isCroppedCard && isArrayWithItems(getInfrastructureElements(infrastructureList, communicationSet)),
  };
}

export const DescriptionLayoutContainer = connect<IDescriptionLayoutStateProps>(mapStateToProps)(DescriptionLayout);
